export const HOME_TAB_LINK_TYPE_V2 = {
  MAIN: 'main',
  SUB_PAGE: 'subPage',
  WEB_PAGE: 'web',
} as const;

export const HOME_TAB_LINK_TYPE_LABEL_V2 = {
  [HOME_TAB_LINK_TYPE_V2.SUB_PAGE]: '서브 페이지',
  [HOME_TAB_LINK_TYPE_V2.WEB_PAGE]: '웹 페이지',
};

export const HOME_TAB_STATUS_TYPE_V2 = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const HOME_TAB_LINK_TYPE_SELECT_LIST_V2 = [
  {
    id: HOME_TAB_LINK_TYPE_V2.SUB_PAGE,
    name: HOME_TAB_LINK_TYPE_LABEL_V2[HOME_TAB_LINK_TYPE_V2.SUB_PAGE],
  },
  {
    id: HOME_TAB_LINK_TYPE_V2.WEB_PAGE,
    name: HOME_TAB_LINK_TYPE_LABEL_V2[HOME_TAB_LINK_TYPE_V2.WEB_PAGE],
  },
];

export const WEB_PAGE_TYPE_V2 = {
  RECOMMENDATION_TAB: 'recommendationTab',
} as const;

export const WEB_PAGE_TYPE_LABEL_V2 = {
  [WEB_PAGE_TYPE_V2.RECOMMENDATION_TAB]: '추천 탭 페이지',
};

export const WEB_PAGE_TYPE_SELECT_LIST_V2 = [
  {
    id: WEB_PAGE_TYPE_V2.RECOMMENDATION_TAB,
    name: WEB_PAGE_TYPE_LABEL_V2[WEB_PAGE_TYPE_V2.RECOMMENDATION_TAB],
  },
];

export const HOME_TYPE_V2 = {
  MAIN: 'main',
  SUB: 'sub',
  WEB: 'web',
} as const;

export const HOME_STATUS_TYPE_V2 = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  DELETE: 'delete',
} as const;

export const RECOMMENDATION_TAB_LINK_URL = '/recommendations/list';

/** 추천 탭 페이지 고정 링크 아이디 */
export const RECOMMENDATION_TAB_LINK_ID = 1;
